<template>
  <div class="review--appointment">
    <v-layout class="review--appointment-container" row wrap>
      <v-flex
        class="review--appointment-content"
        xs12
        md7
        order-xs2
        order-md1>
        <div class="review--appointment-sections" ref="sections">
          <div
            v-if="isServicesEnabled"
            class="review--appointment-section"
            ref="services-section">
            <SummaryEstimate :displayAction="true" />
          </div>

          <div class="review--appointment-section">
            <SummaryLocationDetails :displayAction="true" />
          </div>

          <div class="review--appointment-section">
            <SummaryContact :displayAction="true" />
          </div>
        </div>

        <StepNavigation show-book-appointment />
      </v-flex>

      <v-flex
        class="review--appointment-sidebar"
        xs12
        md4
        offset-md1
        order-xs1
        order-md2>
        <ReviewAppointmentSummary />
        <BookAppointmentButton block jumbo />
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import BookAppointmentButton from '@/components/BookAppointmentButton.vue';
import ReviewAppointmentSummary from '@/components/ReviewAppointmentSummary.vue';
import StepNavigation from '@/components/StepNavigation.vue';
import SummaryContact from '@/components/SummaryContact.vue';
import SummaryEstimate from '@/components/SummaryEstimate.vue';
import SummaryLocationDetails from '@/components/SummaryLocationDetails.vue';
import FeatureFlagUtil from '@/utilities/feature-flag-util';

export default {
  components: {
    BookAppointmentButton,
    ReviewAppointmentSummary,
    StepNavigation,
    SummaryContact,
    SummaryEstimate,
    SummaryLocationDetails,
  },
  data() {
    return {
      isServicesEnabled: FeatureFlagUtil.isServicesEnabled(),
    };
  },
};
</script>

<style lang="scss" scoped>
@import '../styles/mixins/breakpoints';

.review--appointment {
  &-container {
    padding-top: 2.2rem;
  }

  &-section {
    margin-bottom: 2.3rem;

    &:last-child {
      margin-bottom: 0;
    }
  }
}

@include responsive-breakpoint(sm) {
  .review--appointment {
    &-container {
      padding-top: 0.4rem;
    }

    &-sidebar {
      .button--book-appointment {
        display: none;
      }
    }
  }
}
</style>
